import { assertReportSession, reportSessionKey } from './reportSession';
import {http} from './client';
import type {FinanceFilters,FinanceShow} from './financialDashboard';

export interface FinancialResultCalculation {
  revenue:number;revenueSource:'invoice'|'estimate'|'none';payrollActual:number|null;payrollQuoted:number;
  expenses:number;credits:number;totalCosts:number;costBasis:'actual'|'quoted';resultBeforeCommissions:number|null;
  marginBeforeCommissions:number|null;status:'provisional'|'costs_reviewed';pending:string[];
}
export interface FinancialResultRow extends FinanceShow {
  financial:{revision:number;savedAt:string|null;sourceChanged:boolean;canEdit:boolean;calculation:FinancialResultCalculation}|null;
}
export interface FinancialResultsReport {
  rows:FinancialResultRow[];generatedAt:string;limit:number;scope:'all'|'mine';filters:FinanceFilters;
  summary:{shows:number;reviewedShows:number;provisionalShows:number;unavailableShows:number;reviewedRevenue:number|null;reviewedCosts:number|null;reviewedResultBeforeCommissions:number|null;reviewedMarginBeforeCommissions:number|null};
}
export const financialResultsApi={
  async list(filters:FinanceFilters):Promise<FinancialResultsReport>{
    const {response,error}=await http<{data:FinancialResultsReport}>({method:'GET',url:'dashboard/finance/results',isToken:true,params:filters});
    if(error||!response)throw new Error(error?.response?.data?.message||'Could not load current financial results.');
    const result=response.data.data;if(!Array.isArray(result?.rows))throw new Error('The financial results response is invalid.');return result;
  },
  async exportCsv(filters:FinanceFilters):Promise<Blob>{
    const session=reportSessionKey();
    const {response,error}=await http<Blob>({method:'GET',url:'dashboard/finance/results/export',isToken:true,params:filters,file:true});
    if(error||!(response?.data instanceof Blob))throw new Error('Could not export financial results. Narrow the date range or refresh and try again.');assertReportSession(session);return response.data;
  },
};
